<template>
  <div class="sales circular-view-wrap">
    <div
      v-if="series.exchangeGoodsList.length === 0"
      style="padding-top:60%; position: relative;">
      <div
        class="image-slot">
        <i
          class="el-icon-picture-outline"
          style="font-size:40px;"></i>
      </div>
    </div>
    <el-row
      v-else
      :gutter="16">
      <el-col
        v-for="(sitem,index) in series.exchangeGoodsList"
        :key="index"
        :span="span">
        <div
          v-if="series.layoutType === 2"
          class="item-inline">
          <div class="image-wrap">
            <img :src="sitem.goodsSmallImage">
          </div>
          <div class="detail-info">
            <div class="title">{{ sitem.goodsName }}</div>
            <template v-if="sitem.isOngoingSeckillGoods === 1">
              <div
                v-if="sitem.goodsPayType === 1"
                class="point seckill"
                :style="{color: colourStyle[0].colour}">
                <span>¥{{ sitem.seckillPrice }}</span>
                <span class="original-rice">¥{{ sitem.price }}</span>
              </div>
            </template>
            <template v-else>
              <div
                class="point"
                :style="{color: colourStyle[0].colour}">¥{{ sitem.price }}</div>
            </template>
            <el-image
              v-if="orderButtonImage"
              style="width: 80%; margin-top: 8px;"
              :src="orderButtonImage"></el-image>
          </div>
        </div>
        <div
          v-if="series.layoutType === 1"
          class="item-horizontal">
          <div class="item-horizontal-left">
            <img :src="sitem.goodsSmallImage">
          </div>
          <div class="detail-info item-horizontal-right">
            <div class="title">{{ sitem.goodsName }}</div>
            <template v-if="sitem.isOngoingSeckillGoods === 1">
              <div
                v-if="sitem.goodsPayType === 1"
                class="point seckill"
                :style="{color: colourStyle[0].colour}">
                <span>¥{{ sitem.seckillPrice }}</span>
                <span class="original-rice">¥{{ sitem.price }}</span>
              </div>
            </template>
            <template v-else>
              <div
                class="point"
                :style="{color: colourStyle[0].colour}">¥{{ sitem.price }}</div>
            </template>
            <el-image
              v-if="orderButtonImage"
              style="width: 80%; margin-top: 8px;"
              :src="orderButtonImage"></el-image>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import './series.styl'
export default {
  name: 'WeSeriesView',
  props: {
    button: {
      type: Array,
      default() {
        return []
      }
    },
    colourStyle: {
      type: Array,
      default() {
        return [
          { elementType: 'price', colour: '#FF0000' },
          { elementType: 'button', colour: '#1989fa' },
          { elementType: 'header', colour: '#07c160' }
        ]
      }
    },
    series: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    span() {
      return this.series.layoutType === 1 ? 24 : 12
    },
    orderButtonImage() {
      const item = this.button[0] || {}
      return item.url
    }
  }
}
</script>
<style lang="stylus">
.circular-view-wrap {
  position: relative;

  .image-slot {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
  }

  .el-carousel-fix {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    .el-carousel__container {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
